// extracted by mini-css-extract-plugin
module.exports = {"section":"dd31006766--section--zkak5"};